import * as THREE from 'three';
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls'
import { TrackballControls } from 'three/examples/jsm/controls/TrackballControls'
import Stats from 'three/examples/jsm/libs/stats.module'
import { GUI } from 'lil-gui'
import { TorusGeometry, MeshPhongMaterial, DirectionalLight, OrthographicCamera, Vector3, BoxGeometry, MeshBasicMaterial, AmbientLight, Mesh, SphereGeometry, Camera, ObjectLoader } from 'three';
import { Params } from '../data/Params';
import { ReverseObjs } from '../reverse/ReverseObjs';
import { CameraUtil } from '../data/CameraUtil';
import { OBJLoader } from 'three/examples/jsm/loaders/OBJLoader.js'
import { BgObj } from '../reverse/BgObj';
import { FormationData } from '../reverse/FormationData';


export class Main{

    renderer    :THREE.WebGLRenderer;
    scene       :THREE.Scene;
    camera      :THREE.PerspectiveCamera;
    oCamera     :THREE.OrthographicCamera;
    control     :TrackballControls;

    stats       :Stats;
    isDebug     :boolean;
    clock       :THREE.Clock;
    objects     :ReverseObjs;
    loader      :OBJLoader;
    light       :THREE.DirectionalLight;
    rad         :number = 0;

    init(){
    
       FormationData.Init();
       Params.init();

        //// a
        let a = 0;

        //aaa
       /*
       this.loader = new OBJLoader();
       this.loader.load("wire3.obj",(obj)=>{
           let m = obj.children[0] as THREE.Mesh;
           m.material=new MeshBasicMaterial({color:0xff0000});
           m.scale.set(0.1,0.1,0.1);
           Params.wire = m;            
           this.init2();
       })
       */

       this.init2();
    }

    init2(){

       this.clock = new THREE.Clock(true);
       this.clock.start();
    
       this.renderer = new THREE.WebGLRenderer({
           canvas: document.querySelector('#webgl'),
           antialias: true
       });
    

        this.renderer.setPixelRatio(1);
        this.renderer.setClearColor(new THREE.Color(0xcccccc));
        this.renderer.setSize(window.innerWidth,window.innerHeight);
         
        this.scene = new THREE.Scene();
        this.camera = new THREE.PerspectiveCamera(50, window.innerWidth / window.innerHeight, 1, 2000);
        this.camera.position.set(0,0,500);
        this.camera.lookAt(new Vector3());

        let c = new CameraUtil(this.camera);


        this.control = new TrackballControls(this.camera,this.renderer.domElement);
        this.control.enabled=true;
        this.control.rotateSpeed = 2.0;
        this.control.noZoom=true;
        this.control.noRoll=true;
        this.control.noPan=true;
        //this.control.zoomSpeed = 1.2;
        this.control.panSpeed = 2.0;        
       //this.control.enableZoom=false;
        

        window.addEventListener('resize', ()=>{
            this.onWindowResize();
        }, false)
        this.onWindowResize();

        this.light = new DirectionalLight(0xffcccc);
        this.light.intensity=0.7;
        this.light.position.x = 10;
        this.light.position.y = 7;//10;
        this.light.position.z = 10;
        
        /* 
        this.light.castShadow=true;
        this.light.shadow.mapSize.width = 1024; // default
        this.light.shadow.mapSize.height = 1024; // default
        */
        //this.light.shadow.camera //= new THREE.PerspectiveCamera(50, window.innerWidth / window.innerHeight, 1, 2000);
        //this.light.shadow.camera.near = 1; // default
        //this.light.shadow.camera.far = 2000; // default
        

        this.scene.add(this.light);

        let panel = Params.gui.addFolder("cam");

        panel.add(this.light.position,"x",-20,20).name("lightX").listen();
        panel.add(this.light.position,"y",-20,20).name("lightY").listen();
        panel.add(this.light.position,"z",-20,20).name("lightZ").listen();

        panel.add(this.camera.position,"x").name("camX").listen();
        panel.add(this.camera.position,"y").name("camY").listen();
        panel.add(this.camera.position,"z").name("camZ").listen();


        Params.dLight = this.light;

        let aa:AmbientLight = new AmbientLight(0xcccccc);
        this.scene.add(aa);

        this.objects = new ReverseObjs(this.camera);
        this.scene.add(this.objects);

        let mesh = new Mesh(
            new BoxGeometry(1,300,300),
            new MeshPhongMaterial({color:0xcccccc})
        );
        mesh.receiveShadow=true;
        //this.scene.add(mesh)
        

        let bg = new BgObj();
        this.scene.add(bg);


        this.tick();

       
    }

    tick(){
          
        this.control.update();
        this.light.position.x = 10 * Math.cos(this.rad);
        this.light.position.z = 10 * Math.sin(this.rad);
        this.rad+=0.007;
        
        /*
        this.camera.position.x = 500 * Math.cos(this.rad);
        this.camera.position.z = 500 * Math.sin(this.rad);
        this.camera.lookAt(new Vector3());
        this.rad+=0.01;*/
    
        CameraUtil.Instance.UpdateProjectionMatrix();
        

        this.renderer.render(this.scene, this.camera);
        this.objects.update();
        
        //this.renderer.render(this.scene, this.camera);

        window.requestAnimationFrame(()=>{
            this.tick();
        });

    }


    onWindowResize(){

        /*
        const fovRad = (this.camera.fov / 2) * (Math.PI / 180);//角度
        let distance = (window.innerHeight / 2) / Math.tan(fovRad);//距離
        this.camera.position.set(0,0,distance);//距離を指定
        */
        //let scale:number = window.innerHeight/100;//大きさ指定
        this.camera.aspect = window.innerWidth / window.innerHeight;
        this.camera.updateProjectionMatrix();
        //でかい方に合わせるあれ
        let ww:number = window.innerWidth;
        let hh:number = window.innerHeight;
        
        this.renderer.setSize(ww, hh);
    }

}